import { toast } from "sonner";
import { api } from "@/lib/api";

const links = new Map();

// The public share link for a before & after — minted once per pair, then reused.
const shareLink = (key, path) => {
  if (!links.has(key)) {
    links.set(key, api.post(path)
      .then(({ data }) => `${window.location.origin}/api/share/${data.token}`)
      .catch((err) => { links.delete(key); throw err; }));
  }
  return links.get(key);
};

export const galleryShare = (id) => () => shareLink(`g:${id}`, `/share/gallery/${id}`);
export const portalShare = (token, pairId) => () => shareLink(`p:${pairId}`, `/portal/${token}/pairs/${pairId}/share`);
// one photo, clip or pair on the public gallery page — opens it full screen
export const galleryItemUrl = (id) => `${window.location.origin}/gallery?item=${encodeURIComponent(id)}`;

// The phone's share sheet (Messages, WhatsApp…); anywhere without one, copy the link instead.
export const sendShare = async (url, caption, noun = "before & after") => {
  const text = caption ? `Check out this ${noun}: ${caption}` : `Check out this ${noun}`;
  const title = noun === "before & after" ? "Before & after — Solid Home Services" : "Recent work — Solid Home Services";
  if (navigator.share) {
    try {
      await navigator.share({ title, text, url });
      return;
    } catch (err) {
      if (err?.name === "AbortError") return; // they closed the share sheet
    }
  }
  try {
    await navigator.clipboard.writeText(url);
    toast.success("Link copied — paste it into a text.");
  } catch {
    window.prompt("Copy this link to share:", url);
  }
};
